// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"c5-z","dimensionLabel":"d5-z","styleChooserControlWrapper":"e5-z","styleChooserControl":"f5-z","disabled":"g5-z","giftCard":"h5-z","styleChooserText":"i5-z"};